<template>
  <el-dialog
    title="缺失部件查看"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="896px"
    top="30px"
    :close-on-click-modal="false"
  >
    <el-form :model="form" label-position="right" label-width="160px">
      <el-table
        :data="data"
        :summary-method="getSummaries"
        show-summary
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          label="名称"
          prop="CarPartsName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="数量"
          prop="Number"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="重量"
          prop="Weight"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
  
  <script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      activeNames: "1",
      form: {},
      data: [],
    };
  },
  watch: {
    item: {
      handler: function (v) {
        this.$get("VehicleRegistration/GetListByNum", {
          RegistId: v.KeyId,
        }).then((r) => {
          this.data = r.Result;
        });
        this.activeNames = "1";
        this.visible = true;
      },
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += index == 1 ? "件" : "元";
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>
  
  <style>
</style>